const phoneMask = (value: string | undefined, unmasked = false) => {
  if (!value) {
    return '';
  }

  const phone = value.replace(/\D/g, '');

  if (unmasked) {
    return phone;
  }

  if (phone.length === 10) {
    return phone.replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2-$3');
  }

  if (phone.length >= 11) {
    return phone.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '$1 $2 $3-$4');
  }

  return value;
};

const birthdayMask = (value: Date) => {
  const date = new Date(value);
  return `${date.getFullYear()}-${date.getMonth() < 10 ? '0' : ''}${
    date.getMonth() + 1
  }-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
};

const cnpjMask = (value: string | undefined, unmasked = false) => {
  if (!value) {
    return '';
  }

  const cnpj = value.replace(/\D/g, '');

  if (unmasked) {
    return cnpj;
  }

  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

const cepMask = (value: string | undefined, unmasked = false) => {
  if (!value) {
    return '';
  }

  const cep = value.replace(/\D/g, '');

  if (unmasked) {
    return cep;
  }

  return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
};

// Máscara de moeda estilo "digitação por centavos" (cada dígito novo
// entra na casa dos centavos, empurrando o resto pra esquerda) --
// mesmo comportamento de caixa eletrônico/maquininha, evita o usuário
// ter que digitar a vírgula. `unmasked` devolve só o valor numérico
// (em reais, não centavos) pra mandar pro servidor.
const currencyMask = (value: string | undefined, unmasked = false) => {
  if (!value) {
    return '';
  }

  const digits = value.replace(/\D/g, '');

  if (!digits) {
    return '';
  }

  const cents = Number.parseInt(digits, 10);
  const reais = cents / 100;

  if (unmasked) {
    return reais.toFixed(2);
  }

  return reais.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export { phoneMask, birthdayMask, cnpjMask, cepMask, currencyMask };
